(function (upp, $UPP_PROPS, window, navigator) {
    'use strict';
    upp.service('device', [
        function () {

            var $TYPE_PHONE = 'phone',
                $TYPE_DESKTOP = 'desktop',
                $TYPE_TABLET = 'tablet',
                $UNKOWN_DEVICE_ID = 'xxx-xxx-xxxx',
                $OS_IOS = 'ios',
                $OS_ANDROID = 'android',
                deviceType,
                osName,
                touchable = true,
                deviceId, //unique device identification(only for phonegap) [http://en.wikipedia.org/wiki/Universally_Unique_Identifier]
                isSmall = window.matchMedia("(max-width: 650px)").matches;

            /**
             *  PRIVATE FUNCTIONS
             * */

            var _detectDeviceType = function () {
                var device;

                if (touchable) {
                    if (isSmall) {
                        device = $TYPE_PHONE;
                    } else {
                        device = $TYPE_TABLET;
                    }
                } else {
                    device = $TYPE_DESKTOP;
                }
                return device;
            };

            var _detectOsName = function () {
                //TODO: Change 'navigator' to '$window.navigator'
                var os, ua = navigator.userAgent;
                //android
                if (ua.match(/Android/i)) {
                    os = $OS_ANDROID;
                    //ios
                } else if (ua.match(/iPhone|iPad|iPod/i)) {
                    os = $OS_IOS;
                }

                return os;
            };



            /**
             *  INIT
             * */

            deviceType = _detectDeviceType();
            osName = _detectOsName();


            /**
             *  PUBLIC FUNCTIONS
             * */



            /**
             * Check if the app is running in phonegap
             *
             * @method inPhonegap
             * @return {Boolean} Returns true if the app is running in phonegap
             */
            var inPhonegap = function () {
                return  inPhonegap = $UPP_PROPS.PHONEGAP || false; //->to avoid undefined;
            };



            /**
             * Detects the type of the device (phone, tablet or desktop)
             *
             * @method deviceType
             * @return {String} Returns the type of the device
             */

            var getType = function () {
                return deviceType;
            };

            /**
             * Detects if the device is a mobile
             *
             * @method isMobile
             * @return {Boolean} Returns true if it's a mobile
             */
            var isMobile = function () {
                return deviceType === $TYPE_PHONE || deviceType === $TYPE_TABLET;
            };

            /**
             * Detects if the device can be touch
             *
             * @method isTouchable
             * @return {Boolean} Returns true if it's touchable
             */
            var isTouchable = function () {
                return touchable;
            };

            /**
             * Returns the unique identifier of the device, if it's running through phonegap
             *
             * @method getDeviceId
             * @return {String|undefined} Returns the id if running in phonegap
             */
            var getDeviceId = function () {
                return window.device ? window.device.uuid : $UNKOWN_DEVICE_ID;
            };

            /**
             * Returns the name of the operating system
             *
             * @method getOsName
             * @return {String|undefined} Returns the name of the os
             */
            var getOsName = function () {
                return osName;
            };


            return {
                inPhonegap: inPhonegap,
                getType: getType,
                isMobile: isMobile,
                isTouchable: isTouchable,
                getDeviceId: getDeviceId,
                getOsName: getOsName
            }

        }]);
})(upp, $UPP, window, navigator);


// WEBPACK FOOTER //
// ./src/app/common/services/device-service.js